function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import animateScroll from './animateScroll';
import events from './scrollEvents';
var __mapped = {};

var __activeLink;

export default {
  unmount: function unmount() {
    __mapped = {};
  },
  register: function register(name, element) {
    __mapped[name] = element;
  },
  unregister: function unregister(name) {
    delete __mapped[name];
  },
  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByClassName(name)[0];
  },
  setActiveLink: function setActiveLink(link) {
    __activeLink = link;
  },
  getActiveLink: function getActiveLink() {
    return __activeLink;
  },
  scrollTo: function scrollTo(to) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    /*
     * get the mapped DOM element
     */

    var target = this.get(to);

    if (!target) {
      console.warn('target Element not found');
      return;
    }

    var props = _objectSpread({}, options, {
      absolute: false
    });

    if (events.registered.begin) {
      events.registered.begin(to, target);
    }

    var containerId = props.containerId;
    var containerElement = containerId ? document.getElementById(containerId) : null;
    var scrollOffset;

    if (containerId && containerElement) {
      props.absolute = true;

      if (containerElement !== target.offsetParent) {
        if (!containerElement.contains(target)) {
          throw new Error("Container with ID ".concat(containerId, " is not a parent of target ").concat(to));
        } else {
          throw new Error("Container with ID ".concat(containerId, " is not a positioned element"));
        }
      }

      scrollOffset = target.offsetTop;
    } else {
      var coordinates = target.getBoundingClientRect();
      scrollOffset = coordinates.top;
    }

    scrollOffset += props.offset || 0;
    /*
       * if animate is not provided just scroll into the view
       */

    if (!props.smooth) {
      if (containerId && containerElement) {
        containerElement.scrollTop = scrollOffset;
      } else {
        // window.scrollTo accepts only absolute values so body rectangle needs to be subtracted
        var bodyRect = document.body.getBoundingClientRect();
        window.scrollTo(0, scrollOffset - bodyRect.top);
      }

      if (events.registered.end) {
        events.registered.end(to, target);
      }

      return;
    }
    /*
       * Animate scrolling
       */


    animateScroll.animateTopScroll(scrollOffset, props, to, target);
  }
};